import HttpMethod from '@/consts/httpMethod';
import { processRequest, processSuccessResponse, processErrorResponse } from '@/helpers';

export default {
  async getClientDetail(id) {
    const ep = {
      baseURL: process.env.VUE_APP_API_ROOT,
      url: `/v1/clients/${id}/`,
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep);

      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async createClient(data) {
    const ep = {
      baseURL: process.env.VUE_APP_API_ROOT,
      url: '/v1/clients/',
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep, { data });

      const item = processSuccessResponse(res);

      return item;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async updateClient(id, data) {
    const ep = {
      baseURL: process.env.VUE_APP_API_ROOT,
      url: `/v1/clients/${id}/`,
      method: HttpMethod.PATCH
    };

    try {
      const res = await processRequest(ep, { data });

      const item = processSuccessResponse(res);

      return { item };
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async getClientByNationalId(nationalId) {
    const ep = {
      baseURL: process.env.VUE_APP_API_ROOT,
      url: `/v1/clients/citizen-${nationalId}/`,
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep);

      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },
};
